<div
  class="inline-create-container"
  >
  @if (!active) {
    <button
      (click)="active = true"
      class="spot-link"
      type="button"
      >

      <svg plus-icon size="small" />
      <span [textContent]="text.add_setting"></span>
    </button>
  }

  @if (active) {
    <op-project-autocompleter (change)="selectProject($event)"
      (keydown.escape)="active = false"
      [filters]="APIFilters"
      [mapResultsFn]="this.mapProjectsFn.bind(this)"
      [placeholder]="text.please_select"
      dropdownPosition="top"
     />
  }
</div>
